import NewChangesTabs from "../../new-client-dashboard/NewChangesTabs";
import FirmTabReporting from "../tabs/firm-tab-reporting";

const FirmTabHeader = ({ currentPage, mainRef2, mainTabs }) => {
  return (
    <>
      <div
        className="reporting-controls-container d-flex align-items-center justify-content-start"
        style={{ padding: "0px 0px", width: "calc(100% - 100px)" }}
      >
        {/* Control Buttons Row */}
        <div
          className=""
          style={{
            width: "max-content",
          }}
        >
          <NewChangesTabs
            currentTab={currentPage}
            tabsData={mainTabs}
            height={25}
            labelClass=" justify-content-start pe-2"
          />
        </div>
      </div>
      <FirmTabReporting mainRef={mainRef2} />
    </>
  );
};

export default FirmTabHeader;
